import { styled } from '../theme';
import Text from './Text';

const H1 = styled(Text.withComponent('h1'))<{ align?: string }>(({ theme, align = 'left' }) => ({
    fontWeight: theme.typography.fontWeight.medium,
    fontSize: '2.6rem',
    lineHeight: '3.6rem',
    textAlign: align,
}));

export default H1;
